"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("@mdi/react"));
const react_2 = __importDefault(require("react"));
const react_i18next_1 = require("react-i18next");
function ActionButton({ id, action, text, className, icon, disabled, noTrans, }) {
    return (react_2.default.createElement("button", { id: id, className: `button has-text-weight-semibold ${className}`, onClick: () => action(), disabled: disabled },
        icon && react_2.default.createElement(react_1.default, { path: icon.path, size: icon.size }),
        text && react_2.default.createElement(react_2.default.Fragment, null, noTrans ? text : react_2.default.createElement(react_i18next_1.Trans, { i18nKey: text }))));
}
exports.default = ActionButton;
//# sourceMappingURL=ActionButton.js.map